class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.attachEventListeners();
    window.SwymCallbacks.push(this.handleSwymLoad.bind(this));
  }

  attachEventListeners() {
    this.addEventListener('click', this.handleEvent.bind(this));
    this.addEventListener('submit', this.handleEvent.bind(this));
  }

  handleEvent(event) {
    event.preventDefault();
    this.updateCartQuantity();

    // To start swym listener
    document.dispatchEvent(new CustomEvent("swym:collections-loaded"))
  }

  updateCartQuantity() {
    const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
    cartItems.updateQuantity(this.dataset.index, 0);
  }

  handleSwymLoad(swat) {
    if (typeof swat === undefined) {
      console.log('No swat provided to handleSwymLoad', 'background: #222; color: red');
      return
    }
    swat.evtLayer.addEventListener('sw:addedtowishlist', e => this.handleSwymEvent(e, swat));
  }

  async handleSwymEvent(event,swat) {
    if (!event) {
      console.log('No event provided to handleSwymEvent', 'background: #222; color: red');
      return
    }
    const { detail } = event || {};
    const { d } = detail || {};
    const { empi } = d || {};
    const queryString = `[data-cart-product-id="${empi}"]`;
    const productCard = document.querySelector(queryString);
    if (productCard) {
      const variantId = productCard.dataset.variantId || productCard.closest('[data-variant-id]').dataset.variantId;
      const cartItems = productCard.closest('cart-items') || productCard.closest('cart-drawer-items');
      await cartItems.removeItemSimple(variantId, 'swym');
      // Assuming swat.initializeActionButtons is available in the context
      swat.initializeActionButtons('cart-save-for-later');
    }
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.activeConditionManagers = [];

    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source !== 'condition-manager') {
        this.conditionManagerInit();
        this.onCartUpdate();

        return;
      }
      if (event.source === 'cart-items') {
        return;
      }
      if (event.source === 'swym') {
        setTimeout(() => {
          this.onCartUpdate();
        }, 1000);
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  async updateCart(url, sectionId, callback) {
    try {
      const response = await fetch(`${url}?section_id=${sectionId}`);
      const responseText = await response.text();
      callback(responseText);
    } catch (e) {
      console.error(e);
    }
  }

  onCartUpdate() {
    this.updateCart(routes.cart_url, 'main-cart-items', (responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const sourceQty = html.querySelector('cart-items');
      this.innerHTML = sourceQty.innerHTML;

      // To start swym listener
      document.dispatchEvent(new CustomEvent("swym:collections-loaded"))
      initCartRecommendations();
    });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-page-wrapper',
        section:  document.querySelector('[data-cart-section-id]').dataset.cartSectionId,
        selector: '.cart-page-wrapper'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      }
    ];
  }

  disableCheckoutButtons() {
    const checkoutButtons = document.querySelectorAll('button[type="submit"][name="checkout"]');
    checkoutButtons.forEach(button => button.disabled = true);
  }

  handleErrorMessage(errorMessage = false) {
    if (this.hideErrors) return;

    this.errorMessageWrapper =
      this.errorMessageWrapper || this.querySelector('.cart-form__error-message-wrapper');
    if (!this.errorMessageWrapper) return;
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.cart-form__error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }

  async sendCartUpdateRequest(body) {
    return fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then(response => {
        return response.text();
      })
      .then((state) => {
        const response = JSON.parse(state);

        if(response.errors){
          this.handleErrorMessage(response.errors);
        }

        return response;
      });
  }

  handleCartResponse(parsedState, line, name) {
    const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
    const items = document.querySelectorAll('.cart-item');

    if (parsedState.errors) {
      if (!quantityElement) return
      quantityElement.value = quantityElement.getAttribute('value');
      this.updateLiveRegions(line, parsedState.errors);
      return;
    }

    this.classList.toggle('is-empty', parsedState.item_count === 0);
    const cartDrawerWrapper = document.querySelector('cart-drawer');
    const cartFooter = document.getElementById('main-cart-footer');

    if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
    if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

    this.getSectionsToRender().forEach((section) => {
      if (document.getElementById(section.id)) {
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        if (elementToReplace) {
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        }
      }
    });

    const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
    let message = '';
    if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement?.value)) {
      if (typeof updatedValue === 'undefined') {
        if (name === 'swym') return
        message = window.cartStrings.error;
      } else {
        message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
      }
    }
    this.updateLiveRegions(line, message);

    const lineItem =
      document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
    if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
      cartDrawerWrapper
        ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
        : lineItem.querySelector(`[name="${name}"]`).focus();
    } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
      trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
    } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
      trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
    }

    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
  }

  handleCartError(error, name) {
    console.log(error, 'background: #222; color: red');
    this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
    const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
    if (name === 'swym') return;
    if (errors) {
      errors.textContent = window.cartStrings.error;
    }
  }

  updateQuantity(line, quantity, name) {
    this.disableCheckoutButtons();

    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    this.sendCartUpdateRequest(body)
      .then(parsedState => this.handleCartResponse(parsedState, line, name))
      .catch(error => this.handleCartError(error, name))
      .finally(() => {
        this.disableLoading(line);
      });
  }

  async removeItemSimple(variantId, name = '') {
    if (!variantId) {
      console.log('No variant ID provided to removeItemSimple', 'background: #222; color: red');
      return
    }
    this.disableCheckoutButtons();
    
    // More robust selector implementation with fallbacks
    let lineItem = document.querySelector(`[data-variant-id="${variantId}"]`) || 
                   document.querySelector(`tr[data-gift-product][data-variant-id="${variantId}"]`);
    
    // Additional fallback selectors if the primary ones fail
    if (!lineItem) {
      // Try finding by product ID and variant ID together
      const items = document.querySelectorAll('[data-cart-product-id]');
      for (const item of items) {
        const itemVariantId = item.getAttribute('data-variant-id') || 
                             item.closest('[data-variant-id]')?.getAttribute('data-variant-id');
        if (itemVariantId === variantId || itemVariantId === String(variantId)) {
          lineItem = item.closest('tr') || item;
          console.log(`Found item using fallback selector: ${lineItem.tagName}`, 'background: #222; color: green');
          break;
        }
      }

      // Last resort - try by ID only for direct API removal
      if (!lineItem) {
        console.log(`Attempting direct removal for variant ID ${variantId} - item not found in DOM`, 'background: #222; color: orange');
        // We'll still try to remove using direct API call below with variantId
      }
    }
    
    // Get line index either from lineItem or use direct variantId in the request
    let line;
    if (lineItem && lineItem.dataset.index) {
      line = lineItem.dataset.index;
    }
    
    const quantity = 0;

    if (line) {
      this.enableLoading(line);
    }

    // Check if this is a gift product or has special properties
    const isGiftProduct = lineItem?.hasAttribute('data-gift-product') || false;
    const isAutoGiftProduct = lineItem?.hasAttribute('data-auto-gift-product') || 
                              lineItem?.hasAttribute('data-multi-condition-auto-gift-product') || false;
    const isRedeemProduct = lineItem?.hasAttribute('data-redeem-product') || false;
    
    // Use ID-based removal, which is more reliable
    const body = JSON.stringify({
      id: variantId,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    try {
        const parsedState = await this.sendCartUpdateRequest(body);
        if (line) {
          this.handleCartResponse(parsedState, line, name);
        } else {
          // If no line was found, still handle the cart response with a generic update
          setTimeout(() => this.onCartUpdate(), 300);
        }
        
        // If this was a gift product, we might need to refresh to ensure proper state
        if (isGiftProduct || isAutoGiftProduct || isRedeemProduct) {
          setTimeout(() => this.onCartUpdate(), 300);
        }
    } catch (error) {
        this.handleCartError(error, name);
        console.error('Failed to remove item:', error);
    } finally {
        if (line) {
          this.disableLoading(line);
        }
    }
  }

  async addItemSimple(variantId, quantityToAdd = 1, name = '') {
    if (!variantId || quantityToAdd < 1) {
      console.log('No variant ID provided or invalid quantity to addItemSimple', 'background: #222; color: red');
      return;
    }
    this.disableCheckoutButtons();
    const lineItem = document.querySelector(`[data-variant-id="${variantId}"]`);
    let line;
    if (lineItem) {
      line = lineItem.dataset.index;
      this.enableLoading(line);
    }

    // Prepare the body for adding an item. Note: 'quantity' now represents the amount to add.
    const body = JSON.stringify({
      id: variantId,
      quantity: quantityToAdd, // This is the quantity you want to add.
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    try {
      const parsedState = await this.sendCartUpdateRequest(body, 'add'); // Assuming sendCartUpdateRequest supports 'add' action
      this.handleCartResponse(parsedState, line, name);
    } catch (error) {
      this.handleCartError(error, name);
    } finally {
      if (lineItem) {
        this.disableLoading(line);
      }
      this.enableCheckoutButtons();
    }
  }

  conditionManagerInit() {
    const giftProducts = document.querySelectorAll('[data-gift-product]');

    giftProducts.forEach(giftProduct => {
      // constants for each type of gift product
      const redeemProductId = giftProduct.dataset.redeemProduct;
      const autoGiftProductContent = giftProduct.dataset.autoGiftProduct;
      const multiAutoGiftProductContent = giftProduct.dataset.multiConditionAutoGiftProduct;
      const tieredAutoGiftProductContent = giftProduct.dataset.tieredAutoGiftProduct

      // variables for params that will be added to class
      let conditions;
      let options = {
        minimumNeededConditions: 1,
        checkoutButtonSelector: '.cart__checkout-button',
        indexProperty: 'index'
      };
      let selector;

      // set conditions and selector based on gift product type
      if (redeemProductId) {
        conditions = {
          cartTotalMinimum: 1
        };
        selector = `[data-redeem-product="${redeemProductId}"]`;
      } else if (autoGiftProductContent) {
        const autoGiftProductData = JSON.parse(autoGiftProductContent);
        conditions = {
          productInCart: autoGiftProductData.productInCart.map(id => id.toString()),
        };
        selector = `[data-variant-id="${autoGiftProductData.variantId}"]`;
      } else if (multiAutoGiftProductContent) {
        const multiAutoGiftProductContentData = JSON.parse(multiAutoGiftProductContent);
        conditions = {
          multiProductsInCart: multiAutoGiftProductContentData,
        };
        selector = `[data-variant-id="${multiAutoGiftProductContentData.variantId}"]`;
      } else if (tieredAutoGiftProductContent) {
        const tieredAutoGiftProductContentData = JSON.parse(tieredAutoGiftProductContent);
        conditions = {
          cartTotalMinimum: tieredAutoGiftProductContentData.price,
        };
        selector = `[data-variant-id="${tieredAutoGiftProductContentData.variantId}"]`;
      } else {
        console.warn('Unrecognized gift product type:', giftProduct);
        return;
      }

      // check if condition manager is already initialized for this selector
      if (this.activeConditionManagers.includes(selector) && !window.location.href.toLowerCase().includes('cart')) {
        console.warn('ConditionManager already initialized for selector:', selector);
        return;
      }

      // initialize condition manager
      const conditionManagerInstance = new ConditionManager(selector, conditions, options);

      // add selector to active condition managers list
      this.activeConditionManagers.push(selector);
    });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsedElement = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return parsedElement ? parsedElement.innerHTML : null; // Ensure that parsedElement is not null before accessing innerHTML
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

